import React, { useState, useEffect } from "react";
import { IconButton, useColorModeValue } from "@chakra-ui/react";
import { ArrowUpIcon } from "@chakra-ui/icons";

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <IconButton
      icon={<ArrowUpIcon />}
      onClick={scrollToTop}
      position="fixed"
      bottom="4"
      right="4"
      size="lg"
      colorScheme="teal"
      borderRadius="full"
      display={isVisible ? "flex" : "none"}
      aria-label="Back to top"
      boxShadow="lg"
      _hover={{ bg: useColorModeValue("teal.600", "teal.400") }}
    />
  );
};

export default BackToTopButton;
